<template>
    <div class="vin-input" :class="[`vin-input--${type}`, { 'is-invalid': hasError }]">
        <div class="vin-input__control">
            <img class="vin-input__icon" v-if="type == 'dark'" :src="vinIconWhite" alt="">
            <img class="vin-input__icon" v-else :src="vinIcon" alt="">
            <span class="vin-input__divider"></span>
            <input
                class="vin-input__field"
                :value="vin"
                type="text"
                maxlength="17"
                autocomplete="off"
                :placeholder="placeholder"
                aria-label="VIN"
                @input="handleInput"
            >
            <view-button
                type="yellow"
                :size="buttonSize"
                :disabled="!isValid"
                @click="checkVin"
            >
                {{ buttonText }}
            </view-button>
        </div>
        <p v-if="hasError" class="vin-input__error">Invalid VIN. Please correct and re-enter.</p>
    </div>
</template>

<script>
import vinIcon from '@/assets/images/icon/vin-ocr-icon.png';
import vinIconWhite from '@/assets/images/icon/vin-ocr-icon-w.png';
// import { vinPreviewHandle } from "@/api/package";
// console.log(vinPreview, '看看vinpreview')
import ViewButton from '@/components/button.vue'

const vinPattern = /^[A-HJ-NPR-Z0-9]{17}$/;

export default {
    name: 'VinInput',
    components: {
        ViewButton
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'large',
            validator: value => ['large', 'small', 'dark'].includes(value)
        },
        placeholder: {
            type: String,
            default: 'Enter a 17-digit VIN...'
        },
        buttonText: {
            type: String,
            default: 'Check VIN'
        }
    },
    data() {
        return {
            vinIcon,
            vinIconWhite,
            internalValue: this.normalizeVin(this.value),
            hasInteracted: false
        };
    },
    computed: {
        vin() {
            return this.internalValue;
        },
        isValid() {
            return vinPattern.test(this.vin);
        },
        hasError() {
            return this.hasInteracted && this.vin.length > 0 && !this.isValid;
        },
        buttonSize() {
            if (this.type === 'small') return 'small'
            if (this.type === 'dark') return 'dark'
            return 'large'
        }
    },
    watch: {
        value(value) {
            this.internalValue = this.normalizeVin(value);
        }
    },
    methods: {
        normalizeVin(value) {
            return (value || '').toUpperCase().slice(0, 17);
        },
        handleInput(event) {
            const value = this.normalizeVin(event.target.value);
            this.hasInteracted = true;
            this.internalValue = value;
            event.target.value = value;
            this.$emit('input', value);
            this.$emit('validate', { value, valid: vinPattern.test(value) });
        },
        checkVin() {
            if (!this.isValid) return;
            if (!this.$store.state.auth.token) {
                this.$store.dispatch("auth/openLoginDialog")
                return
            }
            // this.$router.push("/order").catch(() => {})
            // this.$emit('check', this.vin);
            import('@/api/package').then(({vinPreviewHandle}) => {
                vinPreviewHandle({vin: this.vin}).then((res) => {
                    let { id } = res.data
                    localStorage.setItem("vin", this.vin)
                    this.$router.push({
                        path: "/order",
                        query: {
                            vinId: id
                        }
                    })
                    // 底部查询区域，跳转到顶部
                    if (this.type === 'dark') {
                        window.scrollTo(0, 0)
                    }
                })
            })
            // vinPreview({
            //     vin: this.vin
            // }).then((res) => {
            //     if (data) {

            //     }
            // })
        }
    }
};
</script>

<style scoped lang="scss">
.vin-input {
    width: 100%;

    &__control {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 8px 8px 8px 16px;
        background: #f6f9ff;
        border: 2px solid #d2ddf0;
        border-radius: 12px;
        box-shadow: 0 0 20px rgba(215, 218, 234, 0.6);
    }

    &__icon {
        flex: 0 0 50px;
        width: 50px;
        height: 50px;
        object-fit: contain;
    }

    &__divider {
        flex: 0 0 1px;
        width: 1px;
        height: 52px;
        margin-left: 12px;
        background: #e8eaf4;
    }

    &__field {
        flex: 1;
        min-width: 0;
        // height: 66px;
        padding: 0 12px;
        color: #333;
        font-size: 24px;
        font-weight: 500;
        letter-spacing: -0.02em;

        &::placeholder {
            color: #bbb;
            opacity: 1;
        }
    }

    &__error {
        height: 20px;
        margin: 14px 0 0;
        color: #e84040;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: -0.02em;
        line-height: 20px;
        text-align: left;
    }

    &.is-invalid {
        .vin-input__control {
            border-color: #e84040;
        }
    }

    &--small {
        .vin-input__icon {
            flex-basis: 32px;
            width: 32px;
            height: 32px;
        }

        .vin-input__divider {
            height: 32px;
        }

        .vin-input__field {
            height: 48px;
            font-size: 16px;
        }
    }
    &--dark {
        .vin-input__control {
            background: rgba(0, 32, 90, 0.38) !important;
            box-shadow: none !important;
            border: none !important;
            padding: 9px 9px 9px 12px;
        }
        .vin-input__icon {
            flex-basis: 35px;
            width: 35px;
            height: 35px;
        }
        .vin-input__divider {
            height: 35px;
        }
        .vin-input__field {
            font-size: 14px;
            color: rgba(255, 255, 255, 1);
            &::placeholder {
                color: rgba(255, 255, 255, 0.8);
                opacity: 1;
            }
        }
        .vin-input__error {
            font-size: 14px;
            color: #FFDD03;
            padding-left: 5px;
        }

    }
}
</style>
